module.exports = __webpack_public_path__ + "img/join3-3-h.b3e04af9.svg";